import React from 'react';
import { StatusDropdown } from './sections/status/StatusDropdown';
import { ListPriceDropdown } from './sections/listPrice/ListPriceDropdown';
import { BedsBathDropdown } from './sections/bedsBaths/BedsBathsDropdown';
import { HomeTypeDropdown } from './sections/homeType/HomeTypeDropdown';
import { SortDropdown } from './sections/sort/SortDropdown';

export const FilterHeader = () => {

  return (
    <div className="flex flex-wrap items-center gap-2">

      <StatusDropdown />
      {/* Price Dropdown */}
      <ListPriceDropdown />

      <BedsBathDropdown />

      <HomeTypeDropdown />

      <SortDropdown />

    </div>
  );
};
